export const chartFiltersTrackers = {
  actions: {
    changePeriodFilter: 'Alterou o filtro de período',
    changeIntervalFilter: 'Alterou o filtro de intervalo',
    changeChartFilter: 'Alterou o tipo de gráfico',
    applyFilters: 'Clicou em aplicar filtros',
    clearFilters: 'Clicou em limpar filtros',
  },
}
